// src/Providers.tsx
import { ReactNode } from "react";

import { ThemeProvider } from "./ThemeContext";
import { ProfileProvider } from "./ProfileContext";

import { AuthProvider } from "./AuthContext";

import { SocketProvider } from "./SocketContext";
import { ContactsProvider } from "./ContactsContext";

import { ChatProvider } from "./ChatContext";
import { MessagesProvider } from "./MessagesContext";

import { LayoutProvider } from "./LayoutContext";
import { BrowserRouter } from "react-router-dom";
import { BookmarkProvider } from "./BookmarkContext";
import { SettingsProvider } from "./SettingsContext";
import { TemplatesProvider } from "./TemplatesContext";
import { ProfileImageProvider } from "./ProfileImageContext";
import { QuickReplyProvider } from "./QuickRepliesContext";
import { UsersProvider } from "./UserContext";
import { SocketWrapper } from "./SocketWrapper";

type ProvidersProps = {
  children: ReactNode;
};


export function Providers({ children }: ProvidersProps) {
  return (
    <BrowserRouter>

      <AuthProvider>

        <SocketWrapper>

          <ThemeProvider>

            <ProfileProvider>   {/* 👈 PROFILE PRIMEIRO */}

              <SettingsProvider>

                <ProfileImageProvider>

                  <UsersProvider>

                    <ContactsProvider>

                      <MessagesProvider> {/* 👈 Messages antes */}

                        <BookmarkProvider>

                          <ChatProvider> {/* 👈 CHAT SEMPRE POR ÚLTIMO */}

                            <TemplatesProvider>
                              <QuickReplyProvider>
                                <LayoutProvider>
                                  {children}
                                </LayoutProvider>
                              </QuickReplyProvider>
                            </TemplatesProvider>

                          </ChatProvider>

                        </BookmarkProvider>

                      </MessagesProvider>

                    </ContactsProvider>

                  </UsersProvider>

                </ProfileImageProvider>

              </SettingsProvider>

            </ProfileProvider>

          </ThemeProvider>

        </SocketWrapper>

      </AuthProvider>

    </BrowserRouter>
  );
}
